import { useEffect, useState } from "react";
import api from "@/lib/api";

export const NAV_LABELS = {
  dashboard: "Dashboard", businesses: "Businesses", timesheet: "Timesheet", atlas: "Atlas", loans: "Assets",
  reminders: "Reminders (menu)", schedule: "Schedule", service: "Service", "daily-logs": "Daily Logs",
};
export const DEFAULT_NAV = { order: Object.keys(NAV_LABELS), hidden: [] };

// Global top-bar config (super admin). Falls back to showing everything.
export function useNavConfig() {
  const [cfg, setCfg] = useState(() => {
    try { return JSON.parse(localStorage.getItem("strata-navbar")) || DEFAULT_NAV; } catch { return DEFAULT_NAV; }
  });
  useEffect(() => {
    const load = () => api.get("/navbar").then(({ data }) => { setCfg(data); localStorage.setItem("strata-navbar", JSON.stringify(data)); }).catch(() => {});
    load();
    window.addEventListener("navbar-updated", load);
    return () => window.removeEventListener("navbar-updated", load);
  }, []);
  return cfg;
}
